import React from "react";
import { Link } from "react-router-dom";
import MyPageBanner from "../components/MyPageBanner";
import field1 from "../images/field1.png";
import HomeTodayMatches from "../components/HomeTodayMatches";
import NewsFeed from "../components/NewsFeed";
import StateMessage from "../components/StateMessage";
import { useSiteSettings } from "../siteSettings";
import {
  useLeagues,
  LeagueLink,
  LeagueListSkeleton,
} from "../components/MyLigasOptions";
import "../components/MyLigasOptions.css";
import "./Home.css";

function SectionHead({ id, title, linkTo, linkLabel }) {
  return (
    <div className="home-section-head">
      <h2 className="home-section-title" id={id}>
        {title}
      </h2>
      {linkTo && (
        <Link to={linkTo} className="home-section-link">
          {linkLabel}
          <span aria-hidden="true"> →</span>
        </Link>
      )}
    </div>
  );
}

function HomeLeagues() {
  const { leagues, loading, error } = useLeagues();
  const active = leagues.filter((l) => !l.archived);

  if (loading) return <LeagueListSkeleton rows={2} />;
  if (error) {
    return <StateMessage kind="error">{error}</StateMessage>;
  }
  if (active.length === 0) {
    return (
      <StateMessage linkTo="/ligas" linkLabel="Ver ligas pasadas">
        No hay ligas activas en este momento.
      </StateMessage>
    );
  }

  return (
    <div className="ligas-list">
      {active.map((league) => (
        <LeagueLink key={league.league_id} league={league} />
      ))}
    </div>
  );
}

function Home() {
  const { loaded, shortName, tagline } = useSiteSettings();

  return (
    <div className="home-page">
      <MyPageBanner
        imageUrl={field1}
        // Non-breaking space keeps the banner height stable until settings load.
        text={loaded ? shortName : "\u00a0"}
        subtitle={loaded ? tagline : null}
      />

      <div className="home-content">
        <section className="home-section home-section--matches" aria-labelledby="home-today-title">
          <SectionHead
            id="home-today-title"
            title="Partidos de hoy"
            linkTo="/partidos"
            linkLabel="Calendario"
          />
          <HomeTodayMatches max={6} />
        </section>

        <aside className="home-aside">
          <section className="home-section" aria-labelledby="home-leagues-title">
            <SectionHead
              id="home-leagues-title"
              title="Ligas activas"
              linkTo="/ligas"
              linkLabel="Todas"
            />
            <p className="home-section-hint">
              Tabla, calendario, goleo y equipos de cada liga.
            </p>
            <HomeLeagues />
          </section>

          <section className="home-section" aria-labelledby="home-news-title">
            <SectionHead
              id="home-news-title"
              title="Noticias"
              linkTo="/noticias"
              linkLabel="Ver todo"
            />
            <NewsFeed showFlyers={false} limit={2} compact />
          </section>
        </aside>
      </div>
    </div>
  );
}

export default Home;
